<script lang="ts">
	import type { ConfigsEntity } from '$lib/api/restApi';
	import { onMount } from 'svelte';

	export let configs: ConfigsEntity[];
	// TODO: Currently the settings page do not allow to setup Google Analytics 4,
	// Universal and Classic is supported, Classic was deprecated in 2017 and Universal is going to be
	// deprecated in 2023, but to allow backwards comparability with Pressly metric extensions
	// https://github.com/vcilabs/hubs-frontend/blob/master/applications/web/docs/extensions.md#metrics
	// analytics.js with Tracking Id (UA-XXXXXX-X) is set up for now, needs to be replaced with
	// gtag.js with Measurement ID (G-XXXXXXX)
	// https://developers.google.com/analytics/devguides/migration/ua/analyticsjs-to-gtagjs#measure_pageviews
	// bluesuede implements a range of different events, that do not seem to work properly (cant see the events in Google Analytics)
	// https://github.com/vcilabs/hubs-frontend/blob/master/applications/web/src/app/domain/tracking/commands/TrackingCommands.js
	// this implementation only supports PageView with auto cookie domain,
	// https://developers.google.com/analytics/devguides/collection/analyticsjs/cookies-user-id#auto

	const gaUniversalConfigs = configs.filter(
		(config) => config.values?.tracker_version === 'universal'
	);
	const ga4Configs = configs.filter((config) => config.values?.tracker_version === 'ga4');

	const gaUniversalCreate = gaUniversalConfigs
		.map((config) => `window.ga('create', '${config.values?.tracking_id || ''}', 'auto')`)
		.join(';');
	const ga4Create = ga4Configs
		.map((config) => `gtag('config', '${config.values?.tracking_id}')`)
		.join(';');

	onMount(() => {
		if (ga4Configs.length) {
			let gaAnalytics4ScriptEl = document.getElementById('gaAnalytics4');
			if (gaAnalytics4ScriptEl) {
				gaAnalytics4ScriptEl.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());${ga4Create};`;
			}
		}

		if (gaUniversalConfigs.length) {
			let gaAnalyticsUniversalScriptEl = document.getElementById('gaAnalyticsU');
			if (gaAnalyticsUniversalScriptEl) {
				// Adapted from https://developers.google.com/analytics/devguides/collection/analyticsjs#the_javascript_measurement_snippet
				gaAnalyticsUniversalScriptEl.innerText = `(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
				${gaUniversalCreate};
				ga('send', 'pageview')`;
			}
		}
	});
</script>

<svelte:head>
	{#if ga4Configs.length}
		<script
			async
			src="https://www.googletagmanager.com/gtag/js?{ga4Configs[0].values.tracking_id}"
		></script>
		<script id="gaAnalytics4"></script>
	{/if}
	{#if gaUniversalConfigs.length}
		<script id="gaAnalyticsU"></script>
	{/if}
</svelte:head>
